import React from 'react'
import { useLocation } from 'react-router-dom'
import { PASEK_NARZEDZI, TRASY_W_MARGINESIE } from '../../config/nawigacja'
import PasekNarzedzi from './PasekNarzedzi'
import { czyAktywna } from './ListaNarzedzi'

/**
 * Środek strony między górnym paskiem a stopką.
 *
 * Na stronach z wyśrodkowaną treścią (`TRASY_W_MARGINESIE`) pasek leży w pustym lewym marginesie
 * (uwaga właściciela 2026-10-07), a odsunięcie (`vv-obok-paska--margines` w index.css) włącza się dopiero,
 * gdy margines jest węższy niż pasek, i tylko o tyle, ile trzeba. Liczone dla treści 80rem (`max-w-7xl`,
 * najszerszy z tych kontenerów). Strony na całą szerokość dostają odsunięcie o szerokość paska.
 *
 * Przy wyłączonej fladze zostaje dokładnie dawny element `flex-grow`.
 */
const UkladZPaskiem = ({ children }) => {
  const { pathname } = useLocation()
  if (!PASEK_NARZEDZI) return <div className='flex-grow'>{children}</div>
  const wMarginesie = czyAktywna({ to: TRASY_W_MARGINESIE[0], takze: TRASY_W_MARGINESIE }, pathname)
  return (
    <div className='flex-grow relative'>
      <PasekNarzedzi />
      <div className={`vv-obok-paska${wMarginesie ? ' vv-obok-paska--margines' : ''} min-w-0`}>{children}</div>
    </div>
  )
}

/**
 * Opakowanie dla elementów przypiętych do lewej krawędzi okna (kafelek
 * „Zgłoś błąd”), żeby stały obok paska, a nie na nim.
 *
 * `fixed` w środku liczy położenie od najbliższego przodka z `transform`, a nie
 * od okna. Opakowanie samo jest `fixed` na całą wysokość, zaczyna się za
 * paskiem i ma zerowe przesunięcie (`translate-x-0`, NIE usuwać), więc
 * `left-6 bottom-6` kafelka liczy się od krawędzi paska. Dzięki temu sam
 * kafelek zostaje bez zmian. `pointer-events-none` przepuszcza kliknięcia do
 * strony pod pustą częścią opakowania, a jego dzieci łapią je z powrotem.
 */
export const ObokPaska = ({ children }) => {
  if (!PASEK_NARZEDZI) return children
  return (
    <div
      className='fixed inset-y-0 right-0 left-0 lg:left-[var(--pasek-narzedzi,0px)] z-40
                 translate-x-0 pointer-events-none [&>*]:pointer-events-auto
                 transition-[left] duration-200 motion-reduce:transition-none'
    >
      {children}
    </div>
  )
}

export default UkladZPaskiem
